/**
 * ExclusionsTab - Employee client exclusions tab
 * Extracted from EmployeeDetailPage to reduce file size
 */
import { Button } from "@/components/ui/button";
import { Plus, Ban } from "lucide-react";

export function ExclusionsTab({
  exclusions,
  onAddExclusion,
  onDeleteExclusion,
}) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-800">
            Client Exclusions ({exclusions.length})
          </h3>
          <p className="text-sm text-slate-500 mt-1">
            Clients this employee cannot be assigned to work with
          </p>
        </div>
        <Button
          size="sm"
          onClick={onAddExclusion}
          className="gap-2"
          data-testid="add-exclusion-btn"
        >
          <Plus className="w-4 h-4" />
          Add Exclusion
        </Button>
      </div>

      {exclusions.length === 0 ? (
        <div className="text-center py-8 text-slate-500 bg-slate-50 rounded-lg">
          <Ban className="w-8 h-8 mx-auto mb-2 opacity-50" />
          <p className="text-sm">No exclusions configured</p>
          <p className="text-xs mt-1">Add exclusions to prevent scheduling conflicts</p>
        </div>
      ) : (
        <div className="space-y-3">
          {exclusions.map((exclusion) => (
            <div
              key={exclusion.id}
              className="flex items-center justify-between p-4 border border-red-100 bg-red-50/50 rounded-lg"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-red-700">
                  <Ban className="w-5 h-5" />
                </div>
                <div>
                  <p className="font-medium text-slate-800">{exclusion.client_name}</p>
                  {exclusion.reason && (
                    <p className="text-sm text-slate-600">Reason: {exclusion.reason}</p>
                  )}
                  <p className="text-xs text-slate-500">
                    Added: {exclusion.created_at ? new Date(exclusion.created_at).toLocaleDateString() : '-'}
                  </p>
                </div>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => onDeleteExclusion(exclusion.id)}
                className="text-red-600 hover:text-red-700"
              >
                Remove
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
